module.exports = __webpack_public_path__ + "static/media/ATS-Logo-Light.1dcc2ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ATS-Logo-Light.png
// module id = 517
// module chunks = 0